export enum EExamType {
  BodyPartExamination = 'body_part_examination',
  BodyPartExaminationObstetrics = 'body_part_examination_obstetrics',
  BodyPartExaminationGynecology = 'body_part_examination_gynecology',
  Diagnosis = 'diagnosis',
  PathologicalProcess = 'pathological_process',
  PhysicalExamination = 'physical_examination',
  SubclinicalDiagnosis = 'subclinical_diagnosis'
}
